const goto = {
	goto_link(link) {
		const el = document.querySelector(link);
        if (el) {
            // 헤더 높이만큼의 오프셋 적용 (고정 헤더가 있을 경우)
            const headerHeight = document.querySelector('.q-header').offsetHeight;
            const elementTop = el.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: elementTop - headerHeight, behavior: 'smooth' });
         }
	},
    clear() {
        window.scrollTo({ top: 0 });
    }
};

export default goto;